const defaultState = () => {
    return {
        userTransactions: [],
        markedTransactions: [],
        fetchingTransactions: false,
    };
};

export default function reducer(state, action) {
    if (!state) {
        return defaultState();
    }
    switch (action.type) {
        case 'FETCH_TRANSACTIONS_FULFILLED':
            return {
                ...state,
                fetchingTransactions: false,
                userTransactions: action.payload.transactions || [],
            };
        case 'FETCH_TRANSACTIONS_PENDING':
            return {
                ...state,
                fetchingTransactions: true,
            };
        case 'FETCH_TRANSACTIONS_REJECTED':
            return {
                ...state,
                fetchingTransactions: false,
            };

        case 'CLEAR_USER_TRANSACTIONS':
            return {
                ...state,
                userTransactions: [],
            };
        case 'SET_MARKED_TRANSACTIONS':
            return {
                ...state,
                markedTransactions: action.payload,
            };
        case 'CLEAR_MARKED_TRANSACTIONS':
            return {
                ...state,
                markedTransactions: [],
            };
        default:
    }
    return state;
}
